import { ChainOrAll } from "database";
import { useMemo } from "react";
import { slice } from "utils/string";
import { trpc } from "@utils";

interface Props {
    walletAddress: string;
    chain?: ChainOrAll;
    ignoreChain?: boolean;
}

const useContact = (props: Props) => {
    const { data, status, isLoading } = trpc.contact.list.useQuery({
        limit: undefined,
        skip: undefined,
    });

    const contact = useMemo(() => {
        if (status !== "success") {
            return undefined;
        }

        return data.find(
            (c) =>
                c.walletAddress.toLowerCase() ===
                    props.walletAddress.toLowerCase() &&
                (c.chain === props.chain ||
                    c.chain === ChainOrAll.ALL ||
                    props.ignoreChain),
        );
    }, [props.walletAddress, props.chain, status, data, props.ignoreChain]);

    const contactNameOrAddress = useMemo(
        () => contact?.name ?? slice(props.walletAddress, 6),
        [contact, props.walletAddress],
    );

    return { contact, contactNameOrAddress, status, isLoading };
};

export default useContact;
